import { useCallback, useState } from 'react';
import { TimeSeriesResponse, TimeSeriesQueryParams, ESnackbarStyle } from 'shared/types';
import { getTimeSeries } from 'services/api/dashboardService';
import { openNotification } from 'utils/notification-utils';

interface UseDashboardTimeSeriesResult {
  timeSeries: TimeSeriesResponse | null;
  isLoading: boolean;
  error: string | null;
  fetchTimeSeries: (params?: TimeSeriesQueryParams) => Promise<void>;
}

const useDashboardTimeSeries = (): UseDashboardTimeSeriesResult => {
  const [timeSeries, setTimeSeries] = useState<TimeSeriesResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTimeSeries = useCallback(async (params?: TimeSeriesQueryParams): Promise<void> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getTimeSeries(params);
      setTimeSeries(response.data);
    } catch (e: any) {
      const errorMessage = e.message || 'Failed to fetch time series data';
      setError(errorMessage);
      openNotification(ESnackbarStyle.ERROR, errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    timeSeries,
    isLoading,
    error,
    fetchTimeSeries
  };
};

export default useDashboardTimeSeries;
